import angular from 'angular';
import { WasThisUsefulMode } from './models/wtu-mode';
import { mergeObjects } from './utilities/merge-objects';
import template from './was-this-useful.component.html';
var WasThisUsefulComponentController = /** @class */ (function () {
    function WasThisUsefulComponentController($location, wasThisUseful) {
        this.$location = $location;
        this.wasThisUseful = wasThisUseful;
        this.WasThisUsefulMode = WasThisUsefulMode;
        this.currentMode = WasThisUsefulMode.None;
        this.selectedMode = WasThisUsefulMode.None;
        this.sending = false;
        this.sent = false;
        this.reasons = [];
        this.resetOnChanges = false;
    }
    WasThisUsefulComponentController.prototype.$onChanges = function () {
        if (this.resetOnChanges) {
            this.currentMode = WasThisUsefulMode.None;
            this.sent = false;
            this.reasons = [];
            this.itemId = '';
        }
    };
    WasThisUsefulComponentController.prototype.onNameChange = function (name) {
        this.userName = name;
    };
    WasThisUsefulComponentController.prototype.sendModel = function (model, final) {
        var _this = this;
        if (final === void 0) { final = true; }
        if (angular.isDefined(this.userName)) {
            return;
        }
        this.sending = true;
        if (!model.pageUrl) {
            model.pageUrl = this.$location.absUrl();
        }
        if (!model.sitecoreId && this.sitecoreId) {
            model.sitecoreId = this.sitecoreId;
        }
        if (!model.id) {
            model.id = this.itemId;
        }
        if (!model.spotName) {
            model.spotName = this.itemLink;
        }
        if (this.additionalDataToSend) {
            mergeObjects(model, this.additionalDataToSend);
        }
        if (final) {
            this.switchMode(WasThisUsefulMode.Sending);
        }
        var sendPromise;
        if (this.itemId) {
            sendPromise = this.wasThisUseful.sendExtraResponse(model, this.itemId);
        }
        else {
            sendPromise = this.wasThisUseful.sendInitialResponse(model);
        }
        sendPromise
            .then(function (response) {
            _this.itemId = response.id;
            _this.reasons = response.reasons;
        })
            .finally(function () {
            _this.sending = false;
            if (!final) {
                return;
            }
            _this.sent = true;
            _this.switchMode(WasThisUsefulMode.Sent);
        });
    };
    WasThisUsefulComponentController.prototype.switchMode = function (mode, sendIfPossible, useful) {
        if (sendIfPossible === void 0) { sendIfPossible = false; }
        if (useful === void 0) { useful = true; }
        if (this.currentMode === mode) {
            this.currentMode = WasThisUsefulMode.None;
        }
        else {
            this.currentMode = mode;
        }
        var reActivatedNoMode = (this.currentMode === WasThisUsefulMode.No && Boolean(this.itemId));
        var isNoneMode = (this.currentMode === WasThisUsefulMode.None);
        if (sendIfPossible && !(reActivatedNoMode || isNoneMode)) {
            this.selectedMode = mode;
            this.sendModel({ useful: useful }, mode !== WasThisUsefulMode.No);
        }
    };
    WasThisUsefulComponentController.prototype.isModeActive = function (mode) {
        return mode === this.currentMode;
    };
    WasThisUsefulComponentController.prototype.getArrowPositionClass = function () {
        switch (this.selectedMode) {
            case WasThisUsefulMode.No:
                return "arrow-below-no";
            case WasThisUsefulMode.Yes:
                return "arrow-below-yes";
            default:
                return "";
        }
    };
    WasThisUsefulComponentController.$inject = ['$location', 'wasThisUseful'];
    return WasThisUsefulComponentController;
}());
export var WasThisUsefulComponent = {
    bindings: {
        additionalDataToSend: '<?',
        contactSupportUrl: '<?',
        itemLink: '<',
        resetOnChanges: '<?',
        sitecoreId: '<',
    },
    controller: WasThisUsefulComponentController,
    template: template,
};
